export enum ContactsDataEventObjectsEnum {
  ACCOUNT_DETAILS = 'account_details',
  COLUMN_SHOWN = 'column_shown',
  COLUMN_HIDDEN = 'column_hidden',
  PROPERTY_DRAGGED = 'property_dragged',
  COLUMN_CONFIG_SEARCHED = 'column_config_searched',
  COLUMN_CONFIG_OPENED = 'column_config_opened',
  ACCOUNT_NOTES_SECTION = 'account_notes_section',
  ACCOUNT_NOTES_EMPTY_STATE = 'account_notes_empty_state',
  ACCOUNT_NOTES_VIEW_MORE = 'account_notes_view_more',
  ACCOUNT_NOTES_LIST = 'account_notes_list',
  ACCOUNT_NOTE = 'account_note',
  ACCOUNT_NOTE_EDIT = 'account_note_edit',
  ACCOUNT_NOTE_DELETE = 'account_note_delete',
  ACCOUNT_NOTE_UNDELETE = 'account_note_undelete',
  ACCOUNTS_SEARCHED = 'accounts_searched',
  MORE_FILTERS_OPENED = 'more_filters_opened',
  FILTERS_CLEARED = 'filters_cleared',
  ACCOUNT_DETAILS_BREADCRUMB = 'account_details_breadcrumb',
  ACCOUNT_DETAILS_VIEW_MORE = 'account_details_view_more',
  ACCOUNT_HEALTH_METRICS_DATE_RANGE = 'account_health_metrics_date_range',
  ACCOUNT_SUMMARY = 'account_summary',
}
